import { render, staticRenderFns } from "./PlanStarted.vue?vue&type=template&id=40529bc4&scoped=true"
import script from "./PlanStarted.vue?vue&type=script&lang=js"
export * from "./PlanStarted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40529bc4",
  null
  
)

export default component.exports